export const STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER = 'STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER';
export const STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS = 'STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_SUCCESS';
export const STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE = 'STATSIG_GET_EVENT_DATA_FOR_STATSIG_USER_FAILURE';
export const STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR = 'STATSIG_GET_EVENT_DATA_FOR_CLEAR_ERROR';
export const STATSIG_SET_TRACK_ANONYMOUS_USERS = 'STATSIG_SET_TRACK_ANONYMOUS_USERS';
